<template>
<div>
    <Head :title="__('Log In')" />

    <div
        v-if="!isDevelopment"
        class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
    >

        <div class="mx-auto py-8 flex justify-center text-black">
            <AppLogo />
        </div>

        <div class="mb-6">
            <GoogleLogin :callback="callback" prompt />
        </div>

    </div>
    <LoginDevelopment v-else />
</div>
</template>

<script>
import Auth from '@/layouts/Auth'
import LoginDevelopment from './LoginDevelopment.vue'

export default {
    name: 'LoginPage',

    components: {
        LoginDevelopment
    },

    layout: Auth,

    computed: {
        isDevelopment() {
            return window.location.hostname === 'local.nova.kintell.com' || window.location.hostname === 'localhost'
        }
    },

    methods: {
        async callback(jwt) {
            const { redirect } = await Nova.form(jwt).post(Nova.url('/google'))

            let path = '/'

            if (redirect !== undefined && redirect !== null) {
                path = { url: redirect, remote: true }
            }

            Nova.visit(path)
        },
    },
}
</script>
<style>
.g-btn-wrapper {
    width: 100%;
    display: block;
    margin-top: 30px;
}
</style>
